import React from 'react';
import { Link } from 'react-router-dom';

/**
 * LegalFooterLinks — a tiny, calm row of Impressum · Privacy · Terms links.
 *
 * Designed to drop into the existing platform footers without disturbing
 * their hierarchy. Renders as a single quiet line in soft taupe, so the
 * studio's footer copy stays the visual lead.
 *
 * Props:
 *   align — 'center' (default) | 'left'
 *   marginTop — px spacing above the row (default 12)
 */
const LINKS = [
  { to: '/impressum', label: 'Impressum' },
  { to: '/privacy',   label: 'Privacy' },
  { to: '/terms',     label: 'Terms' },
];

const LegalFooterLinks = ({ align = 'center', marginTop = 12 }) => (
  <nav
    aria-label="Legal pages"
    data-testid="legal-footer-links"
    style={{
      display: 'flex', gap: 12, alignItems: 'center',
      flexWrap: 'wrap',
      justifyContent: align === 'left' ? 'flex-start' : 'center',
      marginTop,
    }}
  >
    {LINKS.map((l, i) => (
      <React.Fragment key={l.to}>
        {i > 0 && (
          <span aria-hidden="true" style={{ color: 'var(--kahla-text-light)', opacity: 0.45, fontSize: 10 }}>·</span>
        )}
        <Link
          to={l.to}
          data-testid={`footer-legal-${l.label.toLowerCase()}`}
          style={{
            fontSize: 10,
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            color: 'var(--kahla-text-light)',
            textDecoration: 'none',
            opacity: 0.7,
            transition: 'opacity 0.18s ease',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.7)}
        >
          {l.label}
        </Link>
      </React.Fragment>
    ))}
  </nav>
);

export default LegalFooterLinks;
